import styled, {css} from 'styled-components';

const StyledLeftRightContent = styled.section`
  ${({align, bgcolor}) => css`
    display: flex;
    justify-content: center;
    flex-grow: 1;
    padding-top: 60px;
    padding-bottom: 60px;

    ${bgcolor === 'light' &&
    css`
      background: #fff;
    `}

    ${bgcolor === 'default' &&
    css`
      background: #fafafa;
    `}

    ${bgcolor === 'transparent' &&
    css`
      background: transparent;
    `}

    ${align === 'top' &&
    css`
      align-items: flex-start;
    `}

    ${align === 'center' &&
    css`
      align-items: center;
    `}

    ${align === 'bottom' &&
    css`
      align-items: flex-end;
    `}
  `}
`;

export const StyledHeadingDivider = styled.hr`
  ${({theme}) => css`
    display: inline-flex;
    width: 70px;
    height: 3px;
    background: ${theme.palette.secondary.main};
    left: calc(50% - 40px);
    border: none;
    margin-top: 20px;
  `}
`;

export default StyledLeftRightContent;
